module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d6e62"
    }
  }, [_vm._v("The EVERYTHING® Self-Esteem Book ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e142"
    }
  }, [_vm._v("Reader:")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e192"
    }
  }, [_vm._v("I ran away from home on a Monday. I left the South and ran to D.C., Dear to New York Cit y, and further north. Sadly, I did not find happiness or joy at any stop. I didn’t find validation and I didn’t find any place that made me feel any better about myself. "), _c('i', [_vm._v("Where is my happiness? ")]), _vm._v("I questioned. "), _c('i', [_vm._v("Why is no one here to rescue me? Why? Why? Why?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e432"
    }
  }, [_vm._v("I did not have happiness in my heart, my work, my relationships, my traveled for days trying to lose didn’t like me, and I life. I years to home, self-esteem or my years old. It took me twenty-seven I was twenty-seven me that myself. cannot run from ourselves. That trip taught realize that we running; it’s about stopping.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e602"
    }
  }, [_vm._v("In this book, I share the advice and activities that have helped others, and me, over the years. I provide a framework so that "), _c('i', [_vm._v("you can begin your ")]), _c('i', [_vm._v("wor k ")]), _vm._v("to better understand your worth, carve a path to your happiness, uncove r your purpose in life, and move toward an inner peace about the gifts and challenges bestowed on you as a human being.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d6e882"
    }
  }, [_vm._v("All the best to you, ")]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781580629768_ps_0002_001",
      "id": "d14e56",
      "src": "images/9781580629768_ps_0002_001.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ff4b4f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sher_9781440522697_epub_c3_r1.vue
// module id = 66
// module chunks = 0